module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "titlepage"
    }
  }, [_c('h4', {
    staticClass: "author"
  }, [_vm._v("Ellen Key")]), _vm._v(" "), _c('h2', {
    staticClass: "title",
    attrs: {
      "id": "sigil_toc_id_1"
    }
  }, [_vm._v("Über Liebe und Ehe")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('br', {
    staticClass: "chapter"
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("*")]), _vm._v(" "), _c('div', {
    staticClass: "dedication"
  }, [_c('p', {
    staticClass: "calibre1"
  }, [_vm._v("Der Erinnerung an die Toten,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n      die mir in Liebe das Leben gaben"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n      und der Hoffnung auf die Jugend,"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n      die mit neuer Frömmigkeit"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("\n      des Lebens Gabe hüten will.")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-882fa28c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/liebeehe_split_000.vue
// module id = 57
// module chunks = 0